import { useAtomValue } from 'jotai'
import { useMemo } from 'react'
import {
	WidgetInputColorField,
	WidgetInputColorFieldProps,
} from '../../../rapid-ui/inputs/widgets/widget-input-color-field'
import { specialColorLabels, specialColors } from '../../../views/shared/conformed/common/colors'
import { campaignDetailsBrandingAtom } from '../../state'

export type EditorWidgetColorFieldProps = WidgetInputColorFieldProps & {
	includeTransparent?: boolean
}

export function EditorWidgetColorField({ value, onChange, label, includeTransparent }: EditorWidgetColorFieldProps) {
	const branding = useAtomValue(campaignDetailsBrandingAtom)

	const presets = [
		{
			label: specialColorLabels.brandBackground,
			value: specialColors.brandBackground,
			displayColor: branding?.background ?? 'rgba(0,0,0,1)',
		},
		{
			label: specialColorLabels.brandForeground,
			value: specialColors.brandForeground,
			displayColor: branding?.foreground ?? 'rgba(255,255,255,1)',
		},
		{
			label: specialColorLabels.brandAccentBackground,
			value: specialColors.brandAccentBackground,
			displayColor: branding?.accentBackground ?? 'rgba(0,0,0,1)',
		},
		{
			label: specialColorLabels.brandAccentForeground,
			value: specialColors.brandAccentForeground,
			displayColor: branding?.accentForeground ?? 'rgba(255,255,255,1)',
		},
	]

	if (includeTransparent) {
		presets.unshift({
			label: specialColorLabels.transparent,
			value: specialColors.transparent,
			displayColor: 'transparent',
		})
	}

	// Resolve CSS variable values to actual colors for display
	const displayColor = useMemo(() => {
		switch (value) {
			case specialColors.brandBackground:
				return branding?.background ?? 'rgba(0,0,0,1)'
			case specialColors.brandForeground:
				return branding?.foreground ?? 'rgba(255,255,255,1)'
			case specialColors.brandAccentBackground:
				return branding?.accentBackground ?? 'rgba(0,0,0,1)'
			case specialColors.brandAccentForeground:
				return branding?.accentForeground ?? 'rgba(255,255,255,1)'
			case specialColors.transparent:
				return 'transparent'
			default:
				return undefined // Use value directly for hex colors
		}
	}, [value, branding])

	return (
		<WidgetInputColorField
			value={value}
			displayColor={displayColor}
			onChange={onChange}
			label={label}
			presets={presets}
		/>
	)
}
